import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { GetDeviceProfileHeaderResponse, SaveDeviceProfileRequest, SaveDeviceStatusRequest, DeviceDetailSectionResponse, DeviceLifecycleResponse, DeviceStatusResponse } from './type';
export async function getDeviceProfile(id: string): Promise<DeviceDetailSectionResponse> {
  const res = await apiClient.GET('/v4/devices/{id}/profile', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}
export async function saveDeviceProfile(id: string, data: SaveDeviceProfileRequest): Promise<DeviceDetailSectionResponse> {
  const res = await apiClient.POST('/v4/devices/{id}/profile', {
    params: {
      path: {
        id
      }
    },
    body: data
  });
  return getDataOrThrowApiError(res);
}
export async function getDeviceProfileHeader(id: string): Promise<GetDeviceProfileHeaderResponse> {
  const res = await apiClient.GET('/v4/devices/{id}/profile-header', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}
export async function getDeviceLifecycle(id: string): Promise<DeviceLifecycleResponse> {
  const res = await apiClient.GET('/v4/devices/{id}/lifecycle', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}
export async function getDeviceStatus(id: string): Promise<DeviceStatusResponse> {
  const res = await apiClient.GET('/v4/devices/{id}/status', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}
export async function saveDeviceStatus(id: string, data: SaveDeviceStatusRequest): Promise<DeviceStatusResponse> {
  const res = await apiClient.POST('/v4/devices/{id}/status', {
    params: {
      path: {
        id
      }
    },
    body: data
  });
  return getDataOrThrowApiError(res);
}